import { createFileRoute } from '@tanstack/react-router';

import { MisPage, misParams } from '@/features/mis';
import { chartsOpenFrom, chartsParam } from '@/patterns';

export const Route = createFileRoute('/_app/mis/')({
  component: function Mis() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <MisPage params={misParams(search)} showAllBanks={search.banks === 'all'} chartsOpen={chartsOpenFrom(search.charts)} onChartsOpen={(open) => void navigate({ search: (prev) => ({ ...prev, charts: chartsParam(open) }), replace: true })} onShowAllBanks={(all) => void navigate({ search: (prev) => ({ ...prev, banks: all ? 'all' : undefined }), replace: true })} onChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })} />;
  },
});
